import { default as Cache } from "core/cache/Cache";
import makeKey from "./KeyGen.js";
import _ from "lodash";
import Helper from "helper";
import Config from "config";
/// 현재 Singletone 패턴으로 구현되어있으며, 추후 적절한 방법으로 수정 필요

let instance = null;

/**
 * @description Metadata를 제공하는 Provider 현재는 DICOM 데이터에 fix 되어있지만, 여러 데이터에 대해서도 지원하도록
 * 클래스 추상화 필요
 * @class MetadataProvider
 *
 * @export
 * @class MetadataProvider
 */
export default class MetadataCache {
  constructor() {
    if (instance) return instance;

    // Define the main "metadataLookup" private property as an immutable property.
    // How to use defineProperty -> https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
    Object.defineProperty(this, "metadataLookup", {
      configurable: false,
      enumerable: false,
      writable: false,
      value: new Map(),
    });

    // Local reference to provider function bound to current instance.
    Object.defineProperty(this, "_provider", {
      configurable: false,
      enumerable: false,
      writable: true,
      value: null,
    });

    /// 데이터 캐시 생성
    this._metadataCache = new Cache();
    this._metadataMPRCache = new Cache();
    /// Series Instance UID 캐시 생성
    //this._seriesInstanceUIDCache = new Cache();

    instance = this;
    this.metadataStore = null;
  }

  //for temp
  setMetadataStore(store) {
    this.metadataStore = store;
  }

  clear() {
    //this._seriesInstanceUIDCache.clear();
    this._metadataCache.clear();
  }

  /**
   *
   * @param {*} imageId
   */
  get(key) {
    return this._metadataCache.get(key);
  }
  get_all() {
    let keys = this._metadataCache.get_keys();
    var datasets = [];
    keys.forEach((key) => {
      let data = this._metadataCache.get(key);
      datasets.push(data);
    });

    return datasets;
  }

  get_all2(key) {
    let keys = this._metadataCache.get_keys();
    var datasets = [];
    keys.forEach((key) => {
      let data = this._metadataCache.get(key);
      datasets.push(data);
    });

    if (!datasets.length) {
      return null;
    }

    return datasets;
  }
  addMPRData(dataID, MPRData) {
    if (!!dataID === false || !!MPRData === false) {
      return;
    }
    this._metadataMPRCache.set(dataID, MPRData);
  }
  getMPRData(dataID) {
    return this._metadataMPRCache.get(dataID);
  }

  add(seriesInstanceUID, modality, dataset) {
    const studyInstanceUID = dataset.studyInstanceUID;

    ///
    /// 1. 데이터 식별에 사용되는 정보가 존재하지 않는다면 읽기중단.
    ///
    if (!studyInstanceUID || !seriesInstanceUID || !modality) {
      return;
    }

    ///
    /// 2. 데이터 식별 키 생성
    ///
    const seriesInstanceKey = makeKey(seriesInstanceUID, modality);

    //if (!this._seriesInstanceUIDCache.has(seriesInstanceKey)) {
    if (!this._metadataCache.has(seriesInstanceKey)) {
      // Study와 Series가 다른 새로운 데이터 입력됨
      // add
      //this._seriesInstanceUIDCache.set(seriesInstanceKey, seriesInstanceKey);
      this._metadataCache.set(seriesInstanceKey, dataset);

      /// 전체 데이터 병합
      let datasets = this.get_all2(seriesInstanceKey);

      let isFirstData = false;
      if (datasets.length === 1) {
        isFirstData = true;
      }

      if (!datasets) {
        return;
      }

      // publish message to study browser and viewport
      let payload = [];

      for (let i = 0; i < datasets.length; i++) {
        const data = datasets[i];

        if (
          !data.seriesInstanceUID ||
          !data.modality ||
          // !data.studyDate ||
          // !data.studyTime ||
          // !data.seriesNumber ||
          !_.get(data, "stack[0].frame.length", null)
        ) {
          continue;
        }

        const dataSpecDict = {
          seriesID: makeKey(data.seriesInstanceUID, data.modality),
          seriesInstanceUID: data.seriesInstanceUID,
          modality: data.modality,
          seriesDescription: data.seriesDescription || "",
          studyDescription: data.studyDescription || "",
          studyDate: Helper.DateHelper.Format.formatDA(data.studyDate) || "",
          studyTime:
            Helper.DateHelper.Format.formatTM(data.studyTime, "HH:mm:ss") || "",
          seriesNumber: data.seriesNumber || "",
          numOfFrame: data.stack[0].frame.length,
        };
        payload.push(dataSpecDict);

        if (isFirstData) {
          const requestData = {
            viewportIndex: 0,
            seriesInstanceUID: data.seriesInstanceUID,
            modality: data.modality,
          };

          Config.rootStore.gridLayoutStore.setActiveDCMViewIndex(0);

          const key = makeKey(
            requestData.seriesInstanceUID,
            requestData.modality
          );
          if (Config.rootStore.toolbarStore.isBatchViewMode() === false) {
            Config.rootStore.gridLayoutStore.setSeriesMetadataAtDCMView(
              0,
              key,
              0,
              false
              //false
            );
          }
          if (
            Config.rootStore.synchronizationStore.isSupportedSynchronizationOnActive() ===
            true
          ) {
            Config.rootStore.synchronizationStore.reactiveSyncState();
          } else {
            Config.rootStore.synchronizationStore.disableSyncState();
          }
          //Config.rootStore.gridLayoutStore.changeActiveDCMView(0);

          /// Series List에서 특정 study를 활성화 상태로 변경한다.
          Config.rootStore.seriesListStore.setActiveSeriesItem(
            makeKey(data.seriesInstanceUID, data.modality)
          );
        }
      }

      for (let i = 0; i < payload.length; i++) {
        this.metadataStore.add(payload[i].seriesID, payload[i]);
      }
    } else {
      // 이미 동일한 study-series 데이터를 읽음
      // 새로 읽어들인 데이터는 viewport 에만 전달
      // cache에서 study-series 번호가 동일한걸 꺼내서 병합후 다시 저장
      let cacheData = this._metadataCache.get(seriesInstanceKey);
      if (cacheData === undefined) {
        cacheData = dataset;
      } else {
        cacheData.merge(dataset);
      }
      this._metadataCache.set(seriesInstanceKey, cacheData);

      /// 전체 데이터 병합
      let datasets = this.get_all2(seriesInstanceKey);

      if (!datasets) {
        return;
      }

      let payload = [];

      for (let i = 0; i < datasets.length; i++) {
        const data = datasets[i];

        if (
          !data.seriesInstanceUID ||
          !data.modality ||
          !_.get(data, "stack[0].frame.length", null)
        ) {
          continue;
        }

        const dataSpecDict = {
          seriesID: makeKey(data.seriesInstanceUID, data.modality),
          seriesInstanceUID: data.seriesInstanceUID,
          modality: data.modality,
          seriesDescription: data.seriesDescription || "",
          studyDescription: data.studyDescription || "",
          studyDate: Helper.DateHelper.Format.formatDA(data.studyDate) || "",
          studyTime:
            Helper.DateHelper.Format.formatTM(data.studyTime, "HH:mm:ss") || "",
          seriesNumber: data.seriesNumber || "",
          numOfFrame: data.stack[0].frame.length,
        };
        payload.push(dataSpecDict);
      }

      for (let i = 0; i < payload.length; i++) {
        this.metadataStore.add(payload[i].seriesID, payload[i]);
      }
    }
  }

  del(key) {
    if (!this._metadataCache.has(key)) {
      return false;
    }
    let cacheData = this._metadataCache.get(key);
    for (let i = 0; i < cacheData.stack.length; i++) {
      for (let j = 0; j < cacheData.stack[i].frame.length; j++) {
        cacheData.stack[i].frame[j].pixelData = null;
        cacheData.stack[i].frame[j].dump = null;
      }
      //cacheData.stack[i].frame.clear();
      cacheData.stack[i].frame = [];
      cacheData.stack[i].frame = null;
    }
    //cacheData.stack.clear();
    cacheData.stack = [];
    cacheData.stack = null;

    this._metadataCache.del(key);
    return true;
  }

  /**
   * Updates the related metadata for missing fields given a specified image
   *
   * @param image
   */
  update(key, dataset) {
    this._metadataCache.set(key, dataset);
  }
  getThumbnailFrame(key) {
    const data = this._metadataCache.get(key);
    if (!data.stack[0].frame.length) {
      return null;
    }
    const thumbnail = data.stack[0].frame[0];

    return thumbnail;
  }

  getSeriesMaxRescaleSlope(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data || !data.stack[0].frame.length) {
      return null;
    }
    let maxValue = -Number.MAX_VALUE;
    for (let i = 0; i < data.stack[0].frame.length; i++) {
      const image = data.stack[0].frame[i];
      const rescaleSlope = image.rescaleSlope;
      if (maxValue < rescaleSlope) {
        maxValue = rescaleSlope;
      }
    }

    return maxValue;
  }

  getSeriesMinMax(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data || !data.stack[0].frame.length) {
      return null;
    }
    let minValue = Number.MAX_VALUE;
    let maxValue = -Number.MAX_VALUE;
    for (let i = 0; i < data.stack[0].frame.length; i++) {
      const image = data.stack[0].frame[i];
      const minMax = image.minMax;
      if (minValue > minMax[0]) {
        minValue = minMax[0];
      }
      if (maxValue < minMax[1]) {
        maxValue = minMax[1];
      }
    }

    return {
      min: minValue,
      max: maxValue,
    };
  }
  getFrame(seriesID, frameIdx) {
    const data = this._metadataCache.get(seriesID);

    if (!data || !data.stack[0].frame.length) {
      return null;
    }
    const image = data.stack[0].frame[frameIdx];

    return image;
  }

  getFrameMinMax(seriesID, frameIdx) {
    const data = this._metadataCache.get(seriesID);

    if (!data || !data.stack[0].frame.length) {
      return null;
    }
    const image = data.stack[0].frame[frameIdx];

    return image.minMax;
  }

  getRowCosines(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }
    const rowCosines = data.rowCosines;

    return rowCosines;
  }
  getColumnCosines(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }
    const columnCosines = data.columnCosines;

    return columnCosines;
  }
  getNumOfFrame(seriesID) {
    const data = this._metadataCache.get(seriesID);
    if (!data) {
      return 0;
    }
    return data.stack[0].frame.length;
  }

  getVoiLUTModule(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    const voiLUTModule = {
      windowWidth: data.windowWidth,
      windowCenter: data.windowCenter,
    };

    return voiLUTModule;
  }

  getGeneralModule(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    const generalModule = {
      institutionName: data.institutionName,
      institutionAddress: data.institutionAddress,
      acquisitionDate: data.acquisitionDate,
      acquisitionTime: data.acquisitionTime,
    };

    return generalModule;
  }

  getFrameSpecModule(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    const frameSpecModule = {
      rows: data.rows,
      columns: data.columns,
      compression: data.compression,
      pixelSpacing: data.pixelSpacing,
      numOfFrame: data.stack[0].frame.length,
      thickness: data.thickness,
      location: data.location,
    };

    return frameSpecModule;
  }

  getPatientModule(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    const patientModule = {
      name: data.name,
      id: data.id,
      birthdate: data.birthdate,
      sex: data.sex,
    };

    return patientModule;
  }

  getStudyModule(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    const studyModule = {
      studyInstanceUID: data.studyInstanceUID,
      studyDate: data.studyDate,
      studyTime: data.studyTime,
      studyDescription: data.studyDescription,
      studyComment: data.studyComment,
      seriesDescription: data.seriesDescription,
      seriesNumber: data.seriesNumber,
      imageComment: data.imageComment,
    };

    return studyModule;
  }

  getModalityModule(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    const modalityModule = {
      xrayTubeCurrent: data.xrayTubeCurrent,
      KVP: data.KVP,
      fieldStrenth: data.fieldStrenth,
      repetitionTime: data.repetitionTime,
      echoTime: data.echoTime,
    };

    return modalityModule;
  }

  getModalityLUTModule(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    const modalityModule = {
      rescaleSlope: data.rescaleSlope,
      rescaleIntercept: data.rescaleIntercept,
    };

    return modalityModule;
  }

  getModality(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.modality;
  }

  getWindowWidth(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.windowWidth;
  }

  getWindowCenter(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.windowCenter;
  }

  getRows(seriesID, frameIdx) {
    const data = this._metadataCache.get(seriesID);

    if (!data || !data.stack[0].frame.length) {
      return null;
    }
    //const rows = data.stack[0].frame[frameIdx].rows || 0;
    const rows = _.get(data, `stack[0].frame[${frameIdx}].rows`, 0) || 0;

    return rows;
  }

  getColumns(seriesID, frameIdx) {
    const data = this._metadataCache.get(seriesID);

    if (!data || !data.stack[0].frame.length) {
      return null;
    }
    const columns = _.get(data, `stack[0].frame[${frameIdx}].columns`, 0) || 0;
    //const columns = data.stack[0].frame[frameIdx].columns || 0;

    return columns;
  }
  ferer;

  getPatientName(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.patientName;
  }

  getPatientId(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.patientID;
  }

  getPatientBirthDate(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.patientBirthdate;
  }

  getPatientSex(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.patientSex;
  }

  getStudyDate(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.studyDate;
  }

  getStudyTime(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.studyTime;
  }

  getStudyDescription(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.studyDescription;
  }

  getStudyInstanceUID(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.studyInstanceUID;
  }
  getSeriesInstanceUID(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.seriesInstanceUID;
  }
  getSeriesDescription(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.seriesDescription;
  }
  getSeriesNumber(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.seriesNumber;
  }
  getPixelSpacing(seriesID, frameIndex) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    if (!_.get(data, "stack[0].frame[" + frameIndex + "]")) {
      return "";
    }

    return data.stack[0].frame[frameIndex].pixelSpacing;
  }

  isExistPixelSpacing(seriesID, frameIndex) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    if (!_.get(data, "stack[0].frame[" + frameIndex + "]")) {
      return "";
    }

    return data.stack[0].frame[frameIndex].isExistPixelSpacing;
  }

  isUseApproximatePixelSpacing(seriesID, frameIndex) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    if (!_.get(data, "stack[0].frame[" + frameIndex + "]")) {
      return "";
    }

    return data.stack[0].frame[frameIndex].usePixelSpacingApproximateValue;
  }

  isSupportedSync(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return false;
    }
    const numOfFrames = data.stack[0].frame.length;

    let isSupport = true;

    for (let i = 0; i < numOfFrames; i++) {
      const hasPixelSpacing = data.stack[0].frame[i].isExistPixelSpacing;
      const hasImageOrientationPatient = !data.stack[0].frame[i]
        .imageOrientation
        ? false
        : true;
      const hasImagePositionPatient = !data.stack[0].frame[i].imagePosition
        ? false
        : true;

      if (
        hasPixelSpacing === false ||
        hasImageOrientationPatient === false ||
        hasImagePositionPatient === false
      ) {
        isSupport = false;
        break;
      }

      return isSupport;
    }
  }

  getThickness(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.sliceThickness;
  }

  getSliceLocation(seriesID, frameIndex) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }
    if (!_.get(data, "stack[0].frame[frameIndex].sliceLocation")) {
      return null;
    }
    return data.stack[0].frame[frameIndex].sliceLocation;
    //return data.sliceLocation;
  }
  getTablePosition(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    if (!_.get(data, "tablePosition")) {
      return null;
    }

    return data.tablePosition;
  }
  getImagePositionPatient(seriesID, frameIndex) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }
    if (!_.get(data, "stack[0].frame[frameIndex].imagePosition")) {
      return null;
    }
    return data.stack[0].frame[frameIndex].imagePosition;
  }

  getInstitutionName(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.institutionName;
  }

  getInstitutionAddress(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.institutionAddress;
  }

  getKVP(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.KVP;
  }
  getPerformedProcedureStepID(seriesID, frameIndex) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }
    if (!_.get(data, "stack[0].frame[" + frameIndex + "]")) {
      return "";
    }
    return data.stack[0].frame[frameIndex].performedProcedureStepID;
  }
  getAcquisitionDate(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.acquisitionDate;
  }

  getAcquisitionTime(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.acquisitionTime;
  }

  getFrameModality(seriesID, frameIdx) {
    const data = this._metadataCache.get(seriesID);
    if (!!data === false) {
      return "";
    }
    if (!_.get(data, "stack[0].frame[" + frameIdx + "]")) {
      return "";
    }
    return data.stack[0].frame[frameIdx].modality;
  }

  getAcquisitionDateFromFrame(seriesID, frameIndex) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }
    if (!_.get(data, "stack[0].frame[" + frameIndex + "]")) {
      return "";
    }

    return data.stack[0].frame[frameIndex].acquisitionDate;
  }

  getAcquisitionTimeFromFrame(seriesID, frameIndex) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }
    if (!_.get(data, "stack[0].frame[" + frameIndex + "]")) {
      return "";
    }
    return data.stack[0].frame[frameIndex].acquisitionTime;
  }

  getSpacingBetweenSlices(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.pixelSpacing;
  }

  getLossyImageCompression(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.lossyImageCompression;
  }

  getLossyImageCompressionRatio(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.lossyImageCompressionRatio;
  }

  getLossyImageCompressionMethod(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.lossyImageCompressionMethod;
  }
  getStudyID(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.studyID;
  }

  getImageComment(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.imageComment;
  }

  getStudyComment(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.studyComment;
  }

  getFieldStrenth(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.fieldStrenth;
  }

  getRepetitionTime(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.repetitionTime;
  }

  getEchoTime(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return data.echoTime;
  }

  getImagePlaneModule(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    return {
      imagePositionPatient: data.imagePositionPatient,
      rowCosines: data.rowCosines,
      columnCosines: data.columnCosines,
      frameOfReferenceUID: data.frameOfReferenceUID,
      rows: data.rows,
      columns: data.columns,
    };
  }

  getImagePatientPositionBounds(seriesID) {
    const data = this._metadataCache.get(seriesID);

    if (!data) {
      return null;
    }

    let vtkImageData = this._metadataMPRCache.get(seriesID);
    if (!!vtkImageData === false) {
      return null;
    }

    return vtkImageData.getBounds();
  }
}
